<script setup>
import AriaLiveAnnouncer from './components/AriaLiveAnnouncer.vue'
</script>

<template>
  <div class="min-h-screen bg-surface text-ink">
    <AriaLiveAnnouncer />
    <a class="skip-link" href="#main">Skip to main content</a>
    <!-- Each child view declares its own <main id="main">; no wrapper here. -->
    <router-view></router-view>
  </div>
</template>
